import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListIssuedAtCell } from './invoice-list-issued-at.cell';
import { InvoiceListIssuedAtHeader } from './invoice-list-issued-at.header';

export const InvoiceListIssuedAtColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['issuedAt']
> = {
  enableSorting: true,
  header: InvoiceListIssuedAtHeader,
  cell: InvoiceListIssuedAtCell,
  meta: { maxWidth: '165px', width: '160px' },
};
